import { render, staticRenderFns } from "./AdminComponent.vue?vue&type=template&id=7bcae0d5&"
import script from "./AdminComponent.vue?vue&type=script&lang=ts&"
export * from "./AdminComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports